// removed by extract-text-webpack-plugin
module.exports = {"value":"ExtraBar__value___2-udw","extraBarWrapper":"ExtraBar__extraBarWrapper___3Li8X","expand":"ExtraBar__expand___uD_ux","block":"ExtraBar__block___wbTf5","blockNoTooling":"ExtraBar__blockNoTooling___29Pxu","blockInvisible":"ExtraBar__blockInvisible___39eyx","Material":"ExtraBar__Material___1KzHB","Labor":"ExtraBar__Labor___1XHEL","Overhead":"ExtraBar__Overhead___32t5E","Profit":"ExtraBar__Profit___3A5m8","Tooling":"ExtraBar__Tooling___1dlt8","Other":"ExtraBar__Other___KZOSE","toolTip":"ExtraBar__toolTip___cSZC3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StackedBarChart/ExtraBar/ExtraBar.less
// module id = 1246
// module chunks = 0